import { render } from "./UserRolesTable.vue?vue&type=template&id=2654d59e"
import script from "./UserRolesTable.vue?vue&type=script&lang=js"
export * from "./UserRolesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__